import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Output, Input, SimpleChanges, OnChanges } from '@angular/core';

@Component({
	selector: 'app-tablas',
	templateUrl: './tablas.component.html',
	styleUrls: ['./tablas.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class TablasComponent implements OnInit, OnChanges {
	@Input()
	headers: Array<any>;

	@Input()
	body: Array<any>;

	@Input()
	sizeData: number;

	@Input()
	page: number;

	@Input()
	paginar = true;

	@Input()
	filtrar = false;

	@Output()
	valueEmitter = new EventEmitter();

	@Output()
	paginado = new EventEmitter();

	@Output()
	filtros = new EventEmitter();

	@Input()
	pageSize = 12;

	selectData: any;

	constructor() {
	}

	ngOnInit() {
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.body) {
			this.sizeData = this.body.length;
		}
	}

	selectRow(value: any) {
		this.selectData = value;
		this.valueEmitter.emit(value);
	}

	onPaginado(value: any) {
		this.paginado.emit(value);
	}

	getEntries(value: object) {
		return Object.keys(value).map((key) => value[key]);
	}

	onFiltro(evento) {
		this.filtros.emit({ [evento.target.id]: evento.target.value });
	}

}
